import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Modal, Radio } from 'hljd'
import styles from './style.module.less'

@inject('pageStore')
@observer
export default class extends Component {
  render() {
    const {
      visible,
      onChangeDelivery,
      handleOk,
      handleCancel,
      consume_type
    } = this.props.pageStore

    return (
      <Modal
        title="投放方式"
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        width={560}
      >
        <div className={styles.flex}>
          <span className={styles.label}>投放方式</span>
          <div>
            <Radio.Group
              onChange={onChangeDelivery}
              value={String(consume_type)}
            >
              <Radio.Button value={'1'}>常规投放</Radio.Button>
              <Radio.Button value={'2'}>匀速投放</Radio.Button>
            </Radio.Group>
            {consume_type == 1 && (
              <div>
                <p className={styles.tip}>
                  广告持续出现，但在线时间将受影响。系统会尽可能的将广告投放出去，持续出现在相应的广告位，可能会在较短的时间内达到计划曝光量。
                </p>
                <div className={styles.bg}>
                  <img src="https://qnm.hunliji.com/FjMvW9ox0iLYKKPaXOq3tpGLB3Fm" />
                </div>
              </div>
            )}
            {consume_type == 2 && (
              <div>
                <p className={styles.tip}>
                  在线时间长，但广告出现概率有波动。系统会优化您的智推宝流量包大小，控制广告出现概率，尽量在广告投放期间均匀地进行曝光。
                </p>
                <div className={styles.bg}>
                  <img src="https://qnm.hunliji.com/FiOVN0mVMjOQS5wlA4Lg7LLmNIud" />
                </div>
              </div>
            )}
          </div>
        </div>
      </Modal>
    )
  }
}
